const YOUTUBE_ID_PATTERN = /^[a-zA-Z0-9_-]{11}$/;

export const extractYoutubeId = (value) => {
  const input = String(value || '').trim();
  if (!input) return null;

  const iframeMatch = input.match(/<iframe[^>]+src=["']([^"']+)["']/i);
  const source = iframeMatch?.[1] || input;

  try {
    const url = new URL(source);
    const hostname = url.hostname.toLowerCase().replace(/^www\./, '');
    let videoId = '';

    if (hostname === 'youtu.be') {
      videoId = url.pathname.slice(1).split('/')[0];
    }

    if (
      hostname === 'youtube.com' ||
      hostname === 'm.youtube.com' ||
      hostname === 'music.youtube.com' ||
      hostname === 'youtube-nocookie.com'
    ) {
      if (url.pathname === '/watch') {
        videoId = url.searchParams.get('v') || '';
      } else {
        const pathMatch = url.pathname.match(
          /^\/(?:embed|shorts|live|v)\/([^/?#]+)/
        );
        videoId = pathMatch?.[1] || '';
      }
    }

    return YOUTUBE_ID_PATTERN.test(videoId) ? videoId : null;
  } catch {
    return null;
  }
};

const escapeHtml = (value) => String(value || '')
  .replaceAll('&', '&amp;')
  .replaceAll('"', '&quot;')
  .replaceAll('<', '&lt;')
  .replaceAll('>', '&gt;');

export const generateEmbedCode = (videoId, title = 'YouTube Video') => {
  if (!YOUTUBE_ID_PATTERN.test(String(videoId || ''))) {
    return '';
  }

  const safeTitle = escapeHtml(title);
  const origin = escapeHtml(window.location.origin);
  const embedUrl =
    `https://www.youtube.com/embed/${videoId}` +
    `?rel=0&playsinline=1&origin=${encodeURIComponent(origin)}`;

  return `<iframe
  width="560"
  height="315"
  src="${embedUrl}"
  title="${safeTitle}"
  frameborder="0"
  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
  referrerpolicy="origin-when-cross-origin"
  allowfullscreen
></iframe>`;
};

export const openYoutubePlayerPage = (youtubeUrl, title) => {
  const videoId = extractYoutubeId(youtubeUrl);
  if (!videoId) return false;

  const query = new URLSearchParams({
    video: videoId,
    title: title || 'YouTube Video'
  });

  const playerUrl = new URL(
    `/youtube-player.html?${query.toString()}`,
    window.location.origin
  );

  const newTab = window.open(playerUrl.toString(), '_blank');

  if (newTab) {
    newTab.opener = null;
  }

  return newTab !== null;
};